"use client"

import React from 'react'
import { cn } from '@/shared/lib/utils'

interface PhotoDescriptionIndicatorProps {
    hasDescription: boolean
    className?: string
}

/**
 * Visual indicator (3 horizontal lines) shown on photos with descriptions
 * Positioned in the bottom right corner
 */
export default function PhotoDescriptionIndicator({ 
    hasDescription, 
    className 
}: PhotoDescriptionIndicatorProps) {
    if (!hasDescription) return null

    return (
        <div
            className={cn(
                "absolute bottom-2 right-2 bg-black/60 rounded px-1.5 py-1",
                "flex flex-col gap-0.5",
                className
            )}
            aria-label="Photo has description"
        >
            <div className="w-4 h-0.5 bg-white rounded" />
            <div className="w-4 h-0.5 bg-white rounded" />
            <div className="w-4 h-0.5 bg-white rounded" />
        </div>
    )
}

